import Vue from 'vue';
import VueStore from 'vuex';
import authenService from '@/utils/authen';
import {
  LOGIN,
  LOGOUT,
  SET_START_LOADING_MAIN_SCREEN,
  SET_STOP_LOADING_MAIN_SCREEN,
  SET_START_LOADING_ALL_SCREEN,
  SET_STOP_LOADING_ALL_SCREEN,
  ADD_INFO_USER,
  REMOVE_INFO_USER
} from './mutation-types';

import mapDevice from './modules/mapDevice';
import drawMap from './modules/drawMap';

Vue.use(VueStore);

export default new VueStore.Store({
  strict: !process.env.NODE_ENV !== 'production',
  state: {
    logged: false,
    infoUser: {},
    flagLoadingMainScreen: 0,
    flagLoadingAllScreen: 0,
    modeView: '',
    isCollapse: false
  },

  getters: {
    logged: state => state.logged,
    infoUser: state => state.infoUser,
    flagLoadingMainScreen: state => state.flagLoadingMainScreen,
    flagLoadingAllScreen: state => state.flagLoadingAllScreen,
    modeView: state => state.modeView,
    isCollapse: state => state.isCollapse
  },

  actions: {
    LOGIN ({ commit, dispatch }) {
      commit(LOGIN);
    },

    LOGOUT ({ commit, dispatch }) {
      commit(LOGOUT);
    },

    ADD_INFO_USER ({ commit, dispatch }, payload) {
      commit(ADD_INFO_USER, payload);
    },

    REMOVE_INFO_USER ({ commit, dispatch }) {
      commit(REMOVE_INFO_USER);
    },

    SET_START_LOADING_ALL_SCREEN ({ commit, dispatch }) {
      commit(SET_START_LOADING_ALL_SCREEN);
    },

    SET_STOP_LOADING_ALL_SCREEN ({ commit, dispatch }) {
      commit(SET_STOP_LOADING_ALL_SCREEN);
    },

    SET_START_LOADING_MAIN_SCREEN ({ commit, dispatch }) {
      commit(SET_START_LOADING_MAIN_SCREEN);
    },

    SET_STOP_LOADING_MAIN_SCREEN ({ commit, dispatch }) {
      commit(SET_STOP_LOADING_MAIN_SCREEN);
    },

    SET_MODE_VIEW ({ commit, dispatch }, payload) {
      commit('SET_MODE_VIEW', payload);
    },

    SET_COLLAPSE_MENU ({ commit, dispatch }) {
      commit('setCollapseMenu');
    }
  },

  mutations: {
    [LOGIN] (state) {
      state.logged = true;
    },

    [LOGOUT] (state) {
      state.logged = false;
      authenService.removeToken();
      authenService.remove('qlmn_username');
      authenService.remove('qlmn_listDevices');
    },

    [ADD_INFO_USER] (state, payload) {
      state.infoUser = payload;
    },

    [REMOVE_INFO_USER] (state) {
      state.infoUser = {};
    },

    [SET_START_LOADING_MAIN_SCREEN] (state) {
      state.flagLoadingMainScreen++;
    },

    [SET_STOP_LOADING_MAIN_SCREEN] (state) {
      state.flagLoadingMainScreen--;
    },

    [SET_START_LOADING_ALL_SCREEN] (state) {
      state.flagLoadingAllScreen++;
    },

    [SET_STOP_LOADING_ALL_SCREEN] (state) {
      state.flagLoadingAllScreen--;
    },

    SET_MODE_VIEW (state, payload) {
      state.modeView = payload;
    },

    setCollapseMenu (state) {
      state.isCollapse = !state.isCollapse;
    }
  },

  modules: {
    mapDevice,
    drawMap
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js